<template>
  <div>
    <v-card>
      <v-card-title>
        <span v-if="showTitle">List of Employees</span>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @keyup="searchChange"
          autocomplete="off"
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-container v-if="showDense">
          <v-row>
            <v-col>
              <v-checkbox label="Dense" v-model="dense"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-data-table
          :items="filteredItems"
          :headers="headers"
          :loading="loading"
          :footer-props="footerProps"
          :dense="dense"
          item-key="empCode"
          :show-select="showSelect"
          text="Loading... Please wait"
          v-model="selected"
        >
          <template v-slot:header.data-table-select>
            <v-checkbox @change="toggleAll" color="default" v-model="selectAll" value />
            <!-- <v-checkbox
              @change="toggleAll"
              color="default"
              :indeterminate="props.indeterminate"
              value
              v-else
            />-->
          </template>
          <!-- <template slot="items" slot-scope="props">
            <td v-for="(header, index) in headers" :key="index">
              <span>{{ props.item[header.value] }}</span>
            </td>
          </template>-->
          <!-- <template v-slot:item.duties="{ item }">
            <span>yeah</span>
          </template>-->
          <template v-slot:item.action="{ item }">
            <slot name="actions" v-bind:item="item"></slot>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/personalInfo";
import EventBus from "../../../../events/eventBus";
export default {
  props: {
    showTitle: {
      default: true,
      type: Boolean
    },
    showDense: {
      default: true,
      type: Boolean
    },
    headers: {
      default: () => [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "action"
        },
        {
          text: "Employee Code",
          value: "empCode",
          sortable: true
        },
        {
          text: "Lastname",
          value: "lastName",
          sortable: true
        },
        {
          text: "Firstname",
          value: "firstName",
          sortable: true
        },
        {
          text: "Suffix",
          value: "suffix",
          sortable: true
        },
        {
          text: "Middlename",
          value: "middleName",
          sortable: true
        }
      ],
      type: Array
    },
    showSelect: {
      default: false,
      type: Boolean
    },
    dense: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    items: [],
    search: "",
    footerProps: {
      rowsPerPageItems: [10, 25, 50, 100]
    },
    loading: false,
    //dense: false,
    selected: [],
    selectAll: false,
    classPadding: "my-0 py-0"
  }),
  computed: {
    filteredItems() {
      return this.filterItems(this.items, this.search);
    }
  },
  methods: {
    toggleAll() {
      if (this.selectAll) {
        if (this.search !== "") {
          this.selected = this.filteredItems;
        } else {
          this.selected = this.items.slice();
        }
      } else {
        if (this.selected.length) {
          this.selected = [];
        } else {
          if (this.search !== "") {
            this.selected = this.filteredItems;
            this.selectAll = true;
          } else {
            this.selected = this.items.slice();
          }
        }
      }
    },
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectedChanged(val) {
      EventBus.$emit("SELECTED_EMPLOYEE", Object.assign([], val));
    },
    filterItems(items, query) {
      var filtered = items.filter(item => {
        let code = item.empCode.toLowerCase().includes(query.toLowerCase());
        let lastName = item.lastName
          .toLowerCase()
          .includes(query.toLowerCase());

        let firstName = item.firstName
          .toLowerCase()
          .includes(query.toLowerCase());

        if (item.middleName != null) {
          var middleName = item.middleName
            .toLowerCase()
            .includes(query.toLowerCase());
        }

        if (item.suffix != null) {
          var suffix = item.suffix.toLowerCase().includes(query.toLowerCase());
        }

        return code || lastName || firstName || middleName || suffix;
      });
      return filtered;
    },
    searchChange(e) {
      if (e.target.value === "") {
        this.selectAll = false;
        if (this.selected.length === this.items.length) this.selectAll = true;
        else this.selectAll = false;
      }
    }
  },
  created() {
    this.getAll();
  },
  mounted() {
    EventBus.$on("TOGGLE_SELECTED_EMPLOYEE", payload => {
      this.selected = payload;
    });

    EventBus.$on("CLEAR_EMPLOYEE", () => {
      this.selected = [];
    });
  },
  watch: {
    selected(val) {
      this.selectedChanged(val);
      if (this.search !== "") {
        if (val.length !== this.filteredItems.length) this.selectAll = false;
        else this.selectAll = true;
      } else {
        if (val.length !== this.items.length) this.selectAll = false;
        else this.selectAll = true;
      }
    },
    search(val) {
      this.filterItems(this.items, val);
    }
  }
};
</script>